// extracted by mini-css-extract-plugin
export var readonly = "_hp-1";
export var star = "_hp-0";